import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { WelletContext } from '@/context/wellet/welletContext';
import { putMembershipLevel } from '@/services';
import { InputNumberForm, Toast } from '@/uiComponents/common';
import { Save, Users } from 'lucide-react';
import { useContext } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useMutation } from 'react-query';
import { useSelector } from 'react-redux';

const AffiliateCard = ({ t, level }) => {
  const organization = useSelector((state) => state.app.selectedOrganization);
  const welletContext = useContext(WelletContext);
  const methods = useForm({
    defaultValues: {
      id: level?.id ? level?.id : '',
      name: level?.name ? level?.name : '',
      points: 0,
      defaultCommissionPercentageLevel2: 0,
      commission: level?.defaultCommissionPercentage ? level?.defaultCommissionPercentage : 0,
    },
  });
  const affiliateCommissionMutation = useMutation({
    mutationFn: (body) => {
      if (level?.id) {
        return putMembershipLevel(welletContext, organization.marketId, {
          id: level?.id,
          name: body.name,
          targetPoints: 0,
          defaultCommissionPercentage: body.commission,
          defaultCommissionPerPax: 0,
          maxPercentDiscount: 0,
          defaultCommissionPercentageLevel2: body?.defaultCommissionPercentageLevel2,
        });
      } else {
        throw new Error();
      }
    },
  });
  const onSubmit = (data) => {
    let body = {
      name: data?.name,
      defaultCommissionPercentageLevel2: data?.defaultCommissionPercentageLevel2 || 0,
      commission: data?.commission || 0,
    };

    return affiliateCommissionMutation.mutate(body);
  };
  return (
    <>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)} className=''>
          <Card className='tw-p-3 tw-bg-gray-50 tw-mb-6'>
            <CardHeader>
              <div className='tw-flex tw-items-center tw-gap-2'>
                <Users className='tw-h-5 tw-w-5' />
                <CardTitle className='tw-text-base'>
                  {level?.affiliateType === 'INDEPENDENT'
                    ? t('affiliate.title')
                    : t('concierge.title')}
                </CardTitle>
              </div>
              <CardDescription>
                {level?.affiliateType === 'INDEPENDENT'
                  ? t('affiliate.description')
                  : t('concierge.description')}
              </CardDescription>
            </CardHeader>
            <CardContent>
              <div className='tw-flex tw-gap-4'>
                <div className=' tw-flex-1 tw-max-w-xs tw-space-y-2'>
                  <InputNumberForm
                    label={t('affiliate.label')}
                    minNumber={0}
                    inputClassName='tw-bg-white'
                    maxNumber={100}
                    name={'commission'}
                    isRequired={true}
                  />
                </div>
                <Button
                  className='tw-gap-2 tw-mt-[29px]'
                  disabled={!affiliateCommissionMutation.isIdle}
                >
                  <Save className='tw-h-4 tw-w-4' />
                  {t('affiliate.save')}
                </Button>
              </div>
            </CardContent>
          </Card>
        </form>
      </FormProvider>
      {affiliateCommissionMutation?.isSuccess && (
        <Toast
          type={'SUCCESS'}
          message={
            level?.affiliateType === 'INDEPENDENT'
              ? t('affiliate.toast.success')
              : t('concierge.toast.success')
          }
          onCallback={() => affiliateCommissionMutation.reset()}
        />
      )}
      {affiliateCommissionMutation?.isError && (
        <Toast
          type={'ERROR'}
          message={t('affiliate.toast.error')}
          onCallback={() => affiliateCommissionMutation.reset()}
        />
      )}
    </>
  );
};

export default AffiliateCard;
